import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/payment-methods`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/payment-methods/${id}?include=signatures`,
      options
    )
    .then((response) => {
      let paymentMethod = jsona.deserialize(response.data);
      delete paymentMethod.links;
      return paymentMethod;
    });
}

function add(paymentMethod) {
  const payload = jsona.serialize({
    stuff: paymentMethod,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/payment-methods?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(paymentMethod) {
  const payload = jsona.serialize({
    stuff: paymentMethod,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/payment-methods/${paymentMethod.id}?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function validate(paymentMethod) {
  const payload = jsona.serialize({
    stuff: paymentMethod,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/payment-methods/${paymentMethod.id}/validate`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}


function setAsDefault(paymentMethod){
  const payload = jsona.serialize({
    stuff: paymentMethod,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  
  return axios
    .patch(`${url}/payment-methods/${paymentMethod.id}/set-as-default`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function activateOrDeactivate(paymentMethod){
  const payload = jsona.serialize({
    stuff: paymentMethod,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  
  return axios
    .patch(`${url}/payment-methods/${paymentMethod.id}/toggle-activation`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/payment-methods/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  setAsDefault,
  activateOrDeactivate,
  validate
};
